import React from 'react';

import { LoadingOverlay } from '@occc/ui-design-system';
import { ConfirmDialog, Typography } from '@occc/ui-design-system';

type SendOTPCodeModalProps = {
  isOpen: boolean;
  isLoading: boolean;
  onHide: () => void;
  onConfirmButtonClick: () => void;
};

export const SendOTPCodeModal = ({
  isOpen,
  onHide,
  onConfirmButtonClick,
  isLoading,
}: SendOTPCodeModalProps) => {
  return (
    <ConfirmDialog
      dialogTitle='Send OTP Code'
      open={isOpen}
      onClose={onHide}
      fullWidth={true}
      confirmButtonText='Send OTP'
      confirmButtonProps={{ onClick: onConfirmButtonClick }}
    >
      <>
        {isLoading && <LoadingOverlay />}
        <Typography>This code will be sent directly to the member.</Typography>
      </>
    </ConfirmDialog>
  );
};
